import { convertNumbers } from "../../utils/ConvertNumbers";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import Speed from "@material-ui/icons/Speed";
import Button from "@material-ui/core/Button";
import InfoIcon from "@material-ui/icons/Info";
import { Grid, Typography } from "@material-ui/core";
import CounterTypeImg from "../../assets/img/counter.jpg";
import CounterTypeImg2 from "../../assets/img/counter2.jpg";
import CardContent from "@material-ui/core/CardContent";
import { Card } from "@material-ui/core";
import AccountTree from "@material-ui/icons/AccountTree";
import { useHistory } from "react-router";
import { HistoryRounded } from "@material-ui/icons";
import MultiJet from "../../assets/img/multi-jet.png";
import WoltMan from "../../assets/img/woltman.png";
import UltraSonic from "../../assets/img/ultra.png";
import ElectroMagnet from "../../assets/img/electro.png";
import { HOST } from "../../utils/const";
import GasImage from "../../assets/img/gas.jpg";
import PowerImage from "../../assets/img/power.jpg";

const CounterType = (props) => {
  // let image;
  // if (props.data.name.includes("مولتی") && props.data.name.includes("جت")) {
  //   image = MultiJet;
  // } else if (
  //   props.data.name.includes("ولت") &&
  //   props.data.name.includes("من")
  // ) {
  //   image = WoltMan;
  // } else if (props.data.name.includes("سونیک")) {
  //   image = UltraSonic;
  // } else if (
  //   props.data.name.includes("مغناطیس") &&
  //   props.data.name.includes("الکترو")
  // ) {
  //   image = ElectroMagnet;
  // }
  let image;
  if (props.data.images.length > 0) {
    image = HOST + props.data.images[props.data.images.length - 1].fileurl;
  } else {
    if (props.data.category.includes("گاز")) {
      image = GasImage;
    } else if (props.data.category.includes("برق")) {
      image = PowerImage;
    } else if (props.data.category.includes("آب")) {
      image = CounterTypeImg;
    } else {
      image = props.index % 2 === 0 ? CounterTypeImg : CounterTypeImg2;
    }
  }

  const history = useHistory();

  const goToTypeInfo = (e) => {
    history.push("/admin/counter-types/" + props.data.id);
  };

  return (
    <>
      <Grid
        style={{ paddingRight: "8px", paddingLeft: "8px", paddingTop: "40px" }}
        item
        sx={12}
        sm={4}
        md={3}
        lg={2}
      >
        <Card
          align="center"
          style={{ marginBottom: "16px", overflow: "visible" }}
        >
          <img
            src={image}
            style={{
              width: "120px",
              height: "120px",
              borderRadius: "50%",
              marginTop: "-40px",
            }}
            alt="counter-type"
          />
          <CardContent>
            <Typography align="center" style={{ fontWeight: "bold" }}>
              {convertNumbers(props.data.name)}
            </Typography>
            <div
              style={{
                height: "16px",
                borderBottom: "1px solid #e6e9ed",
                marginBottom: "16px",
              }}
            ></div>
            <Grid
              style={{ fontSize: "14px", color: "#73879c" }}
              container
              direction="row"
              alignItems="center"
            >
              <Grid style={{ marginLeft: "2px" }} item>
                <AccountTree />
              </Grid>
              <Grid item>
                <span>استفاده شده در </span>
                {convertNumbers(props.data.projects)}
                <span> پروژه</span>
              </Grid>
            </Grid>
            <Grid
              style={{ fontSize: "14px", color: "#73879c" }}
              container
              direction="row"
              alignItems="center"
            >
              <Grid style={{ marginLeft: "2px" }} item>
                <Speed />
              </Grid>
              <Grid item>
                <span>{convertNumbers(props.data.counters)}</span>
                <span> کنتور ثبت شده</span>
              </Grid>
            </Grid>

            <Grid
              style={{
                fontSize: "14px",
                color: "#73879c",
                paddingTop: "16px",
              }}
              container
              direction="row"
              alignItems="center"
            >
              <Grid item sx={12} sm={12} md={12} lg={12}>
                <Button
                  onClick={goToTypeInfo}
                  style={{
                    width: "100%",
                    color: "#1976d2",
                  }}
                  variant="outlined"
                  endIcon={<InfoIcon />}
                >
                  جزئیات بیشتر
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </>
  );
};

export default CounterType;
